export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./notification.vue?vue&type=template&id=2c0d290a&"


//////////////////
// WEBPACK FOOTER
// ./src/components/notification.vue?vue&type=template&id=2c0d290a&
// module id = null
// module chunks = 